var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "tx_history card"
  }, [_c('div', {
    staticClass: "header"
  }, [_c('h2', {
    staticClass: "top_info_heading"
  }, [_vm._v(" Transaction Volume "), _c('TooltipHeading', {
    attrs: {
      "content": "for P and X-chains only"
    }
  })], 1)]), _c('div', {
    staticClass: "history_cont"
  }, [_c('div', {
    staticClass: "chart_toggle_settings"
  }, [_c('button', {
    attrs: {
      "active": _vm.scope === _vm.options[1]
    },
    on: {
      "click": function click($event) {
        return _vm.setScope(_vm.options[1]);
      }
    }
  }, [_vm._v(" 1 mo ")]), _c('button', {
    attrs: {
      "active": _vm.scope === _vm.options[2]
    },
    on: {
      "click": function click($event) {
        return _vm.setScope(_vm.options[2]);
      }
    }
  }, [_vm._v(" 1 week ")]), _c('button', {
    attrs: {
      "active": _vm.scope === _vm.options[3]
    },
    on: {
      "click": function click($event) {
        return _vm.setScope(_vm.options[3]);
      }
    }
  }, [_vm._v(" 1 day ")]), _c('button', {
    attrs: {
      "active": _vm.scope === _vm.options[4]
    },
    on: {
      "click": function click($event) {
        return _vm.setScope(_vm.options[4]);
      }
    }
  }, [_vm._v(" 1 hr ")]), _c('button', {
    attrs: {
      "active": _vm.scope === _vm.options[5]
    },
    on: {
      "click": function click($event) {
        return _vm.setScope(_vm.options[5]);
      }
    }
  }, [_vm._v(" 1 min ")])]), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.loading,
      expression: "loading"
    }],
    staticClass: "loading_cont"
  }, [_c('v-progress-circular', {
    attrs: {
      "size": 16,
      "width": 2,
      "color": "#E84970",
      "indeterminate": ""
    }
  })], 1), _c('div', {
    staticClass: "canv_cont"
  }, [_c('canvas', {
    ref: "canv"
  })]), _vm.aggregates && !_vm.loading ? [_c('TransactionHistoryMeta', {
    attrs: {
      "aggregates": _vm.aggregates,
      "scope": _vm.scope
    }
  })] : _vm._e()], 2)]);
}
var staticRenderFns = []

export { render, staticRenderFns }